<template>
  <Dialog :commonDialog="dialog" :dialogWidth="dialogWidth">
    <template v-slot:title>
      <v-layout>
        <v-flex> Manage Vehicle Location </v-flex>
        <v-flex class="text-right">
          <v-btn small class="mx-4" v-on:click="createEquipmentLocation">
            <span class="font-size-16 font-weight-600"
              >Add Vehicle Location</span
            >
          </v-btn>
        </v-flex>
      </v-layout>
    </template>
    <template v-slot:body>
      <perfect-scrollbar
        :options="{ suppressScrollX: true }"
        class="scroll custom-box-top-inner-shadow"
        style="max-height: 90vh; position: relative"
      >
                <v-form
                  ref="locationForm"
                  v-model.trim="formValid"
                  lazy-validation
                  v-on:submit.stop.prevent="updateEquipmentLocation"
                >
        <v-container class="py-0">
          <v-row class="py-0">
            <v-col md="12" class="py-0">
              <table class="width-100">
                
                <tbody>
                  <tr v-for="(type, index) in equipmentList" :key="index">
                    <td>
                      <v-text-field
                        v-model.trim="type.text"
                        dense
                        filled
                        label="Vehicle Location"
                        solo
                        flat
                        class="px-4 py-2"
                        hide-details
                        :disabled="pageLoading"
                        :loading="pageLoading"
                        color="cyan"
                         :rules="[
                            validateRules.required(type.text, 'vehicle location')
                          ]"
                      ></v-text-field>
                    </td>
                    <td width="50">
                      <v-tooltip top content-class="custom-top-tooltip">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            v-on:click="deleteEquipmentLocation(index)"
                            color="deep-orange"
                            v-bind="attrs"
                            v-on="on"
                            >mdi-delete</v-icon
                          >
                        </template>
                        <span>Click here to delete</span>
                      </v-tooltip>
                    </td>
                  </tr>
                </tbody>
                
              </table>
            </v-col>
          </v-row>
        </v-container>
        </v-form>
      </perfect-scrollbar>
    </template>
    <template v-slot:action>
      <v-btn
        :disabled="pageLoading"
        :loading="pageLoading"
        class="mx-2 custom-grey-border custom-bold-button white--text"
        color="cyan"
        v-on:click="updateEquipmentLocation"
      >
        Save
      </v-btn>
      <v-btn
        :disabled="pageLoading"
        class="mx-2 custom-grey-border custom-bold-button"
        v-on:click="$emit('close-dialog', true)"
      >
        Close
      </v-btn>
    </template>
  </Dialog>
</template>
<script>
import Dialog from "@/view/pages/partials/Dialog.vue";
import { PATCH } from "@/core/services/store/request.module";
import ValidationMixin from "@/core/plugins/validation-mixin";
import {
  ErrorEventBus,
  InitializeError,
} from "@/core/lib/message.lib";
export default {
  mixins: [ValidationMixin],
  props: {
    dialog: {
      type: Boolean,
      required: true,
      default: false,
    },
    equipment: {
      type: Array,
      default: () => {
        return new Array();
      },
    },
  },
  watch: {
    equipment: {
      deep: true,
      immediate: true,
      handler(param) {
        this.equipmentList = param;
      },
    },
  },
  data: () => {
    return {
      pageLoading: false,
     
      equipmentList: [
        {
          text: null,
        },
      ],
    };
  },
  methods: {
    updateEquipmentLocation() {

       const isValid = this.$refs["locationForm"].validate();
       this.formValid = isValid;
       const formErrors = this.validateForm(this.$refs["locationForm"]);
      if (!isValid || formErrors.length) {
        for (let i = 0; i < formErrors.length; i++) {
          ErrorEventBus.$emit("update:error", InitializeError(formErrors[i]));
        }
        return false;
      }

      const _this = this;
      _this.pageLoading = true;
      _this.$store
        .dispatch(PATCH, {
          url: "setting/equipment-location",
          data: { equipment_location: _this.equipmentList },
        })
        .then(() => {
          _this.$emit("close-dialog", true);
          _this.$emit("get-equipment-location", true);
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.pageLoading = false;
        });
    },
    createEquipmentLocation() {
      this.equipmentList.push({
        text: null,
      });
    },
    deleteEquipmentLocation(index) {
      if (this.equipmentList.length > 1) {
        this.equipmentList.splice(index, 1);
      }
    },
  },
  components: {
    Dialog,
  },
  computed: {
    dialogWidth() {
      return this.lodash.toSafeInteger((document.body.clientWidth / 100) * 50);
    },
  },
};
</script>
